import { render, staticRenderFns } from "./EditDeliveryForm.vue?vue&type=template&id=a82d2e9a&scoped=true"
import script from "./EditDeliveryForm.vue?vue&type=script&lang=js"
export * from "./EditDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./EditDeliveryForm.vue?vue&type=style&index=0&id=a82d2e9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82d2e9a",
  null
  
)

export default component.exports